import { render, staticRenderFns } from "./WatchParallax.vue?vue&type=template&id=57bc38ad&"
import script from "./WatchParallax.vue?vue&type=script&lang=js&"
export * from "./WatchParallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports